<div class="flex-fill d-flex flex-column" *ngIf="entity">
    <div class="btn-toolbar mx-3 mb-0 mt-3">
        <button type="button" (click)="save()" class="btn btn-primary me-2" *ngIf="hasChanges()">Save</button>
        <button type="button" (click)="cancel()" class="btn btn-success" *ngIf="hasChanges()">Cancel</button>
        <button type="button" (click)="close()" class="btn btn-primary" *ngIf="!hasChanges()">Close</button>
    </div>
    <div class="grid-fill m-3">
        <dx-form [formData]="entity" [validationGroup]="validationGroup" *ngIf="entity" [colCount]="3">
            <dxi-item itemType="group">
                <dxi-item dataField="userName" [label]="{ text: 'Username' }" [editorOptions]="{ name: 'new-username' }">
                    <dxi-validation-rule type="required" message="Username Required"> </dxi-validation-rule>
                    <dxi-validation-rule type="async" message="Username is already in use" [validationCallback]="validateUsername" reevaluate="true"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="firstName" [label]="{ text: 'First Name' }">
                </dxi-item>
                <dxi-item dataField="lastName" [label]="{ text: 'Last Name' }">
                </dxi-item>
                <dxi-item dataField="email" [label]="{ text: 'Email' }">
                    <dxi-validation-rule type="email" message="Invalid email format"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="active" [label]="{ text: 'Active' }">
                </dxi-item>
                <dxi-item dataField="newPassword" [editorOptions]="{ mode: 'password', name: 'new-password', onValueChanged: onValueChanged, valueChangeEvent: 'keyup' }">
                    <dxi-validation-rule type="custom" message="Password cannot contain any spaces" [validationCallback]="validatePasswordSpaces" reevaluate="true"></dxi-validation-rule>
                    <dxi-validation-rule type="custom" message="Password must be at least 8 characters in length" [validationCallback]="validatePassword" reevaluate="true"></dxi-validation-rule>
                    <dxi-validation-rule type="custom" message="Password required for new users" [validationCallback]="validatePasswordRequired" reevaluate="true"></dxi-validation-rule>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group">
                <dxi-item [label]="{ text: 'Roles' }">
                    <div *dxTemplate>
                        <dx-list [items]="roles"
                                 keyExpr="id"
                                 [(selectedItemKeys)]="selectedRoleIds"
                                 selectionMode="multiple"
                                 [showSelectionControls]="true"
                                 itemTemplate="listItem"
                                 class="wrap roles-list"
                                 (onSelectionChanged)="onSelectionChanged($event)">
                            <div *dxTemplate="let item of 'listItem'">
                                {{ item.name }}
                            </div>
                        </dx-list>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</div>
